import { Tooltip } from '@mui/material';

export type CheckboxLabelProps = {
    label: string;
    bold?: boolean;
    gap?: string;
    labelStyles?: React.CSSProperties;
};

const CheckboxLabel = ({ label, bold = false, gap, labelStyles }: CheckboxLabelProps) => {
    const fontWeight = bold ? { fontWeight: 600 } : { fontWeight: 400 };
    const marginLeft = gap ? { marginLeft: gap } : { marginLeft: '14px' };
    return (
        <Tooltip title={label}>
            <span
                style={{
                    ...marginLeft,
                    color: '#282828',
                    fontFamily: 'Assistant, sans-serif',
                    fontSize: '15px',
                    lineHeight: '20px',
                    ...fontWeight,
                    ...labelStyles,
                }}
            >
                {label}
            </span>
        </Tooltip>
    );
};

export default CheckboxLabel;
